import React, { useState, useRef, useEffect } from "react";
import GlgLoadingSpinner from "../../shared/components/glg_loading_spinner";
import GlgInlineLoadingSpinner from "../../shared/components/glg_loading_spinner_inline";

export const SearchSelect = ({ 
  options, 
  handleSearchChange, 
  handleSelectChange, 
  placeholder,
  renderTrigger,
  isLoading
}) => {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (handleSearchChange && value.length >= 3) handleSearchChange(value);
  };

  const handleItemClick = (option) => {
    setSelectedItem(option);
    setIsOpen(false);
    setQuery("");
    handleSelectChange(option.value);
  };

  const DropdownContent = () => {
    if (isLoading) {
      return <GlgInlineLoadingSpinner show={isLoading} className='add-margin-left-10 add-margin-bottom-10 add-margin-top-10'/>;
    }
    
    if (query.length < 3) {
      return <li className="search-select-hint">Please enter 3 or more characters</li>;
    }
    
    if (options?.length > 0) {
      return options.map((option) => (
        <li key={option.value} onClick={() => handleItemClick(option)} className="search-select-item">
          <span>{option.label}</span>
        </li>
      ));
    }

    return <li className="search-select-hint">No results found</li>;
  }

  return (
    <div ref={containerRef} className="search-select-container">
      <div onClick={() => setIsOpen(!isOpen)}>
        {renderTrigger ? (
          renderTrigger(selectedItem, isOpen)
        ) : (
          <div className="search-select-trigger">
            {selectedItem ? selectedItem.label : placeholder}
            <i className="fa fa-caret-down"></i>
          </div>
        )}
      </div>

      {isOpen && (
        <ul className="search-select-dropdown">
          <li className="search-select-search-container">
            <input
              autoFocus
              type="text"
              value={query}
              onChange={handleInputChange}
              className="search-select-input"
              onClick={(e) => e.stopPropagation()}
            />
          </li>
          <DropdownContent/>
        </ul>
      )}
    </div>
  );
};